export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  accent: "primary" | "accent" | "secondary";
}

export interface TimelineItem {
  time: string;
  text: string;
}

export interface Topic {
  id: string;
  title: string;
  summary: string;
  categorySlug: string;
  body: string[];
  timeline: TimelineItem[];
  tags: string[];
  heat: number;
  heatWeek: number;
  heatMonth: number;
  trend: "up" | "down" | "new" | "flat";
  reads: number;
  comments: number;
  publishedAt: string;
  image: string;
  featured?: boolean;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  {
    slug: "yule",
    name: "娱乐八卦",
    description: "艺人动态、经纪公司声明、演唱会与综艺周边的第一手讨论焦点。",
    icon: "ri-mic-2-line",
    image: "https://readdy.ai/api/search-image?query=Warm%20coral%20red%20abstract%20editorial%20background%20with%20soft%20gradient%20shapes%20and%20grain%20texture%2C%20minimal%20magazine%20art%20direction%2C%20dramatic%20warm%20light%2C%20no%20text%2C%20no%20people%2C%20clean%20high%20detail%20composition&width=800&height=600&seq=gua-cat-yule-01&orientation=landscape",
    accent: "primary",
  },
  {
    slug: "yingshi",
    name: "影视综",
    description: "新剧口碑、选角争议、综艺名场面，追剧党最关心的热搜都在这里。",
    icon: "ri-film-line",
    image: "https://readdy.ai/api/search-image?query=Deep%20teal%20and%20amber%20abstract%20geometric%20composition%20with%20soft%20film%20grain%2C%20cinematic%20light%20streaks%2C%20minimal%20editorial%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail%20shadows&width=800&height=600&seq=gua-cat-yingshi-02&orientation=landscape",
    accent: "secondary",
  },
  {
    slug: "shehui",
    name: "社会焦点",
    description: "城市里正在发生的事：公共事件反转、民生话题与社区讨论。",
    icon: "ri-building-2-line",
    image: "https://readdy.ai/api/search-image?query=Muted%20warm%20beige%20abstract%20city%20skyline%20silhouette%20made%20of%20soft%20geometric%20blocks%2C%20editorial%20minimalist%20style%2C%20gentle%20amber%20light%2C%20no%20text%2C%20clean%20high%20detail%20composition&width=800&height=600&seq=gua-cat-shehui-03&orientation=landscape",
    accent: "accent",
  },
  {
    slug: "keji",
    name: "科技数码",
    description: "新机发布、价格争议、AI 工具落地，科技圈的瓜一样精彩。",
    icon: "ri-smartphone-line",
    image: "https://readdy.ai/api/search-image?query=Dark%20charcoal%20abstract%20technology%20background%20with%20glowing%20amber%20and%20teal%20geometric%20lines%2C%20soft%20grain%2C%20minimal%20futuristic%20editorial%20style%2C%20no%20text%2C%20high%20detail%20contrast&width=800&height=600&seq=gua-cat-keji-04&orientation=landscape",
    accent: "secondary",
  },
  {
    slug: "tiyu",
    name: "体育赛事",
    description: "绝杀、破纪录、判罚争议，赛场内外的话题一夜之间就能刷屏。",
    icon: "ri-basketball-line",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20warm%20orange%20abstract%20motion%20blur%20background%20with%20bold%20geometric%20shapes%2C%20energetic%20editorial%20sport%20poster%20direction%2C%20soft%20grain%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gua-cat-tiyu-05&orientation=landscape",
    accent: "primary",
  },
  {
    slug: "shenghuo",
    name: "生活方式",
    description: "夜跑、国货联名、城市市集，年轻人正在过的日子就是最好的谈资。",
    icon: "ri-cup-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20cream%20and%20sage%20green%20abstract%20lifestyle%20background%20with%20organic%20rounded%20shapes%20and%20subtle%20grain%2C%20calm%20minimal%20editorial%20style%2C%20warm%20natural%20light%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=gua-cat-shenghuo-06&orientation=landscape",
    accent: "accent",
  },
];

export const topics: Topic[] = [
  {
    id: "changye-weiguang-finale",
    title: "《长夜微光》大结局口碑两极，观众把讨论区吵上了热榜",
    summary:
      "悬疑剧《长夜微光》迎来收官，开放式结局让追了两个月的观众分成两派，有人称之为年度最佳，也有人直呼被留白劝退。",
    categorySlug: "yingshi",
    body: [
      "昨晚《长夜微光》播出最后一集，主线谜题终于落地，但编剧选择用一个不算圆满的开放式镜头收尾，把主角的去向留在了画面之外。播出后不到一小时，相关讨论就冲上了多个平台的话题区。",
      "支持的一方认为，这种留白正好呼应了全剧“真相未必有唯一答案”的主题，收尾克制且有余味；反对的一方则表示，追了三十多集就等一个清晰的交代，情绪落点被生生掐断，难以接受。",
      "剧方今早在官方账号发布了一段主创访谈，提到结局其实拍摄了两个版本，最终选择了更“安静”的那一版。至于是否会放出另一个版本的番外，官方只回复了“敬请期待”。",
      "有意思的是，这场争论反而让该剧的播放量在收官后继续上涨，不少新观众表示“就想看看大家到底在吵什么”。",
    ],
    timeline: [
      { time: "昨晚 20:00", text: "大结局上线，开放结尾引发首轮讨论" },
      { time: "昨晚 21:30", text: "相关话题进入多个平台热搜前列" },
      { time: "今早 09:00", text: "剧方发布主创访谈回应结局设计" },
    ],
    tags: ["长夜微光", "大结局", "追剧讨论"],
    heat: 98650,
    heatWeek: 432100,
    heatMonth: 612400,
    trend: "up",
    reads: 128400,
    comments: 5320,
    publishedAt: "2026-09-10 08:40",
    image: "https://readdy.ai/api/search-image?query=Teal%20and%20amber%20abstract%20cinematic%20background%20with%20a%20single%20warm%20light%20beam%20cutting%20through%20soft%20film%20grain%2C%20minimal%20editorial%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail%20shadows&width=800&height=450&seq=gua-topic-01&orientation=landscape",
    featured: true,
  },
  {
    id: "linyueran-live-response",
    title: "歌手林悦然直播翻车？现场回应引发二次热议",
    summary:
      "一场原本轻松的线上直播，因为一段临场回应被剪成短视频疯传，工作室凌晨发声明澄清，但讨论并没有停下来。",
    categorySlug: "yule",
    body: [
      "前晚的线上直播里，歌手林悦然在回答弹幕提问时，用了一句被部分观众认为语气偏冲的回应。片段被剪成十五秒短视频后，几小时内传播量破百万。",
      "凌晨一点，工作室发布声明，表示当时是设备延迟导致口型与声音不同步，林悦然本人也在评论区补充说明，称自己只是想开个玩笑，没有针对任何人。",
      "不过网友们显然更关心画面之外的细节，有人翻出直播全程逐帧对比，也有人认为这不过是被放大的普通互动。截至目前，该话题的讨论量仍在缓慢上涨。",
    ],
    timeline: [
      { time: "前晚 21:15", text: "直播片段被剪成短视频开始传播" },
      { time: "昨日 01:00", text: "工作室发布正式声明回应" },
      { time: "今日 07:20", text: "话题热度回升，进入热议合集榜单" },
    ],
    tags: ["林悦然", "直播", "工作室声明"],
    heat: 91240,
    heatWeek: 356800,
    heatMonth: 401200,
    trend: "flat",
    reads: 96200,
    comments: 4180,
    publishedAt: "2026-09-10 07:55",
    image: "https://readdy.ai/api/search-image?query=Bold%20coral%20red%20abstract%20stage%20light%20background%20with%20soft%20gradient%20halo%20and%20grain%20texture%2C%20minimal%20editorial%20concert%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-02&orientation=landscape",
    featured: true,
  },
  {
    id: "foldable-phone-pricing",
    title: "新款折叠屏发布，定价策略成了最大争议点",
    summary:
      "硬件升级幅度不小，但价格一分没降，发布会结束后讨论区的焦点几乎全部落在“值不值”上。",
    categorySlug: "keji",
    body: [
      "昨晚的发布会上，厂商用近一半时间讲影像与铰链，新增的铰链结构让整机厚度下降明显，官方宣称折痕问题得到进一步改善。",
      "但价格公布环节引发了直播间弹幕的集中吐槽——起售价与上一代完全一致，而用户期待的“以旧换新加码”并没有出现。",
      "也有理性声音指出，同价位段里能做到这个轻薄度的产品并不多，真正的争议点其实在于“升级够不够打动老用户换机”。多家测评机构表示会在三天内给出详细对比。",
    ],
    timeline: [
      { time: "昨晚 19:30", text: "新品发布会开始，硬件参数公开" },
      { time: "昨晚 20:50", text: "价格公布，弹幕集中讨论" },
      { time: "今日 09:30", text: "首批实机上手内容陆续释出" },
    ],
    tags: ["折叠屏", "新品发布", "定价"],
    heat: 87310,
    heatWeek: 298700,
    heatMonth: 322100,
    trend: "up",
    reads: 88400,
    comments: 3960,
    publishedAt: "2026-09-10 07:10",
    image: "https://readdy.ai/api/search-image?query=Dark%20charcoal%20abstract%20technology%20background%20with%20glowing%20amber%20folded%20geometric%20planes%20and%20soft%20grain%2C%20minimal%20futuristic%20editorial%20style%2C%20no%20text%2C%20high%20detail%20contrast&width=800&height=450&seq=gua-topic-03&orientation=landscape",
    featured: true,
  },
  {
    id: "city-night-run-boom",
    title: "城市夜跑活动意外爆火，报名通道一度被挤到卡顿",
    summary:
      "一场原本只发在社区群里的夜跑活动，因为一条短视频出圈，两天内报名人数翻了十几倍。",
    categorySlug: "shenghuo",
    body: [
      "活动最初只是一条发布在社区群里的通知，路线沿着滨江步道，全程约六公里，名额三百人。有参与者拍了一段夜跑视频发到短视频平台后，画面里的江景与灯带迅速被转发。",
      "第二天上午，主办方临时把小程序的报名上限调高，但通道仍一度卡顿。工作人员表示，正在协调志愿者与补给点，尽量保证体验。",
      "有趣的是，评论区里讨论最多的不是跑步本身，而是“这条路线到底几点人最少”，不少人已经在自发整理错峰攻略。",
    ],
    timeline: [
      { time: "前日 22:00", text: "夜跑短视频在平台走红" },
      { time: "昨日 10:20", text: "报名通道出现明显卡顿" },
      { time: "今日 08:00", text: "主办方追加志愿者与补给点" },
    ],
    tags: ["夜跑", "城市生活", "滨江步道"],
    heat: 82150,
    heatWeek: 265300,
    heatMonth: 288600,
    trend: "new",
    reads: 74200,
    comments: 2870,
    publishedAt: "2026-09-10 06:45",
    image: "https://readdy.ai/api/search-image?query=Soft%20sage%20green%20and%20cream%20abstract%20running%20track%20curves%20with%20warm%20night%20light%20streaks%20and%20grain%2C%20calm%20minimal%20editorial%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-04&orientation=landscape",
    featured: true,
  },
  {
    id: "league-overtime-buzzer",
    title: "联赛焦点战加时绝杀，终场判罚再上热搜",
    summary:
      "一场被提前预告为“必看”的强强对话，最后两分钟出现了两次争议判罚，赛后双方教练的表态同样耐人寻味。",
    categorySlug: "tiyu",
    body: [
      "常规时间最后 40 秒，比分仍然咬得很紧，一次压哨投篮把比赛拖入加时。加时赛还剩 3 秒，主队完成绝杀，全场沸腾。",
      "争议出现在加时中段的一次进攻犯规判罚，慢镜头显示接触幅度并不算大。赛后客队教练在采访中只说了一句“大家看回放就好”，被网友反复解读。",
      "联盟方面表示，会在今天公布最后两分钟的裁判报告。无论结论如何，这场比赛的技术统计已经在多个平台被球迷逐条拆解。",
    ],
    timeline: [
      { time: "昨晚 21:40", text: "常规时间压哨追平，进入加时" },
      { time: "昨晚 22:05", text: "主队完成绝杀，比赛结束" },
      { time: "今日 10:00", text: "联盟将公布最后两分钟裁判报告" },
    ],
    tags: ["联赛", "加时绝杀", "判罚争议"],
    heat: 79880,
    heatWeek: 244900,
    heatMonth: 251300,
    trend: "up",
    reads: 71300,
    comments: 3410,
    publishedAt: "2026-09-10 09:05",
    image: "https://readdy.ai/api/search-image?query=Bold%20orange%20abstract%20sports%20court%20geometry%20with%20motion%20blur%20arcs%20and%20soft%20grain%20texture%2C%20energetic%20minimal%20editorial%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-05&orientation=landscape",
  },
  {
    id: "station-honesty-reversal",
    title: "车站拾金不昧事件反转，监控还原了完整经过",
    summary:
      "一条“失主冷漠”的帖子引发众怒，不到半天，完整监控让舆论方向彻底调转。",
    categorySlug: "shehui",
    body: [
      "事件起因是一位乘客发帖称，自己在车站捡到财物归还后，失主态度冷淡、连一句道谢都没有，帖子迅速获得大量转发。",
      "当天下午，车站方面公布了事发时段的完整监控，画面显示双方交流时间很短，失主当时正在接听一个紧急电话，归还后确有口头致谢。",
      "发帖人随后更新说明，称自己当时情绪不佳、表述不够完整，并向对方致歉。这条反转也让不少网友开始反思“先入为主”的讨论习惯。",
    ],
    timeline: [
      { time: "昨日 12:10", text: "失主冷漠帖文开始大范围传播" },
      { time: "昨日 17:40", text: "车站公布完整监控画面" },
      { time: "昨日 20:30", text: "发帖人更新说明并致歉" },
    ],
    tags: ["车站", "事件反转", "监控"],
    heat: 76420,
    heatWeek: 221600,
    heatMonth: 234800,
    trend: "down",
    reads: 68500,
    comments: 4520,
    publishedAt: "2026-09-09 21:15",
    image: "https://readdy.ai/api/search-image?query=Muted%20warm%20beige%20abstract%20train%20station%20geometry%20with%20soft%20amber%20light%20and%20grain%20texture%2C%20calm%20minimal%20editorial%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-06&orientation=landscape",
  },
  {
    id: "weekend-no-overtime-show",
    title: "综艺《周末不加班》嘉宾互怼，节目组当晚回应",
    summary:
      "节目里一段不到两分钟的对话被剪成多个版本传播，观众对“是效果还是真火气”争论不休。",
    categorySlug: "yingshi",
    body: [
      "最新一期《周末不加班》的游戏环节中，两位常驻嘉宾因为规则理解产生分歧，场面一度安静了几秒，随后被另一位嘉宾打圆场。",
      "节目播出当晚，节目组在官方账号回应称，所有环节都按照规则进行，剪辑保留了真实反应，没有刻意制造冲突。",
      "观众的关注点很快从对话本身转移到“综艺到底该怎么平衡真实与效果”上，这反而让本期节目的讨论度创下开播以来新高。",
    ],
    timeline: [
      { time: "上周六 20:30", text: "节目播出，互怼片段被广泛传播" },
      { time: "上周六 22:10", text: "节目组发布官方回应" },
      { time: "昨日", text: "话题延伸至综艺制作讨论" },
    ],
    tags: ["周末不加班", "综艺", "嘉宾互动"],
    heat: 71640,
    heatWeek: 208400,
    heatMonth: 219900,
    trend: "down",
    reads: 62400,
    comments: 2680,
    publishedAt: "2026-09-09 18:20",
    image: "https://readdy.ai/api/search-image?query=Playful%20teal%20and%20coral%20abstract%20studio%20set%20geometry%20with%20soft%20gradient%20and%20grain%2C%20warm%20editorial%20variety%20show%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-07&orientation=landscape",
  },
  {
    id: "girlgroup-solo-rumor",
    title: "女团成员单飞传闻发酵，经纪公司深夜发声明",
    summary:
      "起因只是一条行程调整通知，几小时后便演变成“单飞”猜测，公司选择在凌晨直接回应。",
    categorySlug: "yule",
    body: [
      "昨天下午，经纪公司调整了某女团成员近期的公开行程，原本排定的两场见面会改由其他成员出席，这一变动被粉丝注意到。",
      "随后有账号发布长文，称该成员正在筹备个人项目。话题迅速发酵，相关词条在深夜进入讨论榜前列。",
      "凌晨两点，经纪公司发布声明，明确表示行程调整只是正常的档期协调，团体的后续计划不会有变化，并呼吁不要传播未经确认的消息。",
    ],
    timeline: [
      { time: "昨日 15:00", text: "公开行程调整引发粉丝讨论" },
      { time: "昨日 23:30", text: "单飞传闻词条进入热议榜" },
      { time: "今日 02:00", text: "经纪公司发布深夜声明" },
    ],
    tags: ["女团", "单飞传闻", "经纪公司"],
    heat: 68930,
    heatWeek: 194300,
    heatMonth: 201700,
    trend: "new",
    reads: 59700,
    comments: 3120,
    publishedAt: "2026-09-10 03:10",
    image: "https://readdy.ai/api/search-image?query=Soft%20pink%20coral%20abstract%20spotlight%20circles%20with%20gentle%20gradient%20and%20film%20grain%2C%20minimal%20editorial%20stage%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-08&orientation=landscape",
  },
  {
    id: "ai-assistant-office-debate",
    title: "AI 助手接入日常办公，打工人态度两极分化",
    summary:
      "某办公平台上线 AI 助手默认入口后，效率派和担忧派在同一栋写字楼里吵了起来。",
    categorySlug: "keji",
    body: [
      "平台在上周更新中把 AI 助手放到了默认侧边栏，写周报、整理会议纪要、生成表格都能一键完成，官方称可节省大量重复劳动。",
      "支持的用户晒出自己的使用截图，表示原本两小时的整理工作现在十分钟能搞定；反对的用户则担心默认开启会带来数据与边界问题。",
      "平台回应称，相关功能可以随时关闭，文档内容是否用于处理完全由用户授权决定，并承诺会在下个版本提供更细的权限开关。",
    ],
    timeline: [
      { time: "上周三", text: "平台更新，AI 助手默认置顶" },
      { time: "本周一", text: "效率与隐私讨论同步升温" },
      { time: "今日", text: "平台承诺下版本细化权限开关" },
    ],
    tags: ["AI 助手", "办公效率", "隐私讨论"],
    heat: 65210,
    heatWeek: 187600,
    heatMonth: 192300,
    trend: "flat",
    reads: 56300,
    comments: 2950,
    publishedAt: "2026-09-09 16:40",
    image: "https://readdy.ai/api/search-image?query=Deep%20charcoal%20abstract%20data%20grid%20with%20glowing%20amber%20nodes%20and%20teal%20lines%2C%20soft%20grain%2C%20minimal%20editorial%20technology%20style%2C%20no%20text%2C%20high%20detail%20contrast&width=800&height=450&seq=gua-topic-09&orientation=landscape",
  },
  {
    id: "guochao-collab-soldout",
    title: "老牌国货联名上新，首发十分钟就售罄",
    summary:
      "两个看起来毫不相干的品牌走到一起，结果首发库存被抢空，二手平台的价格已经翻了一倍。",
    categorySlug: "shenghuo",
    body: [
      "这次联名把经典国货的包装语言和一家新锐茶饮的视觉放在一起，限定款只做了一批，官方在预热阶段就明确表示“售完不补”。",
      "开售十分钟后，线上渠道显示全部售罄，线下门店则出现了排队现象。有买到的人在社交平台晒单，也有人开始整理“还有哪些门店可能有货”。",
      "品牌方回应称，正在评估是否需要追加一轮，但为了不影响限定属性，数量会严格控制。",
    ],
    timeline: [
      { time: "昨日 10:00", text: "联名款正式开售" },
      { time: "昨日 10:12", text: "线上渠道全部售罄" },
      { time: "今日 09:00", text: "品牌方回应追加评估中" },
    ],
    tags: ["国货联名", "限定款", "售罄"],
    heat: 61870,
    heatWeek: 172800,
    heatMonth: 181500,
    trend: "down",
    reads: 52100,
    comments: 2140,
    publishedAt: "2026-09-09 14:25",
    image: "https://readdy.ai/api/search-image?query=Warm%20cream%20and%20amber%20abstract%20product%20packaging%20geometry%20with%20soft%20shadow%20and%20grain%2C%20clean%20minimal%20editorial%20style%2C%20no%20text%2C%20high%20detail&width=800&height=450&seq=gua-topic-10&orientation=landscape",
  },
  {
    id: "rookie-record-debut",
    title: "国家队新人首秀就破纪录，教练赛后采访意外走红",
    summary:
      "赛前几乎没人认识的名字，在首秀里交出了一份远超预期的成绩单，赛后那句点评被剪成了无数版本。",
    categorySlug: "tiyu",
    body: [
      "这位首次入选的年轻选手在预赛就刷新了个人最好成绩，决赛中更进一步，直接改写了该项目近三年的国内纪录。",
      "真正出圈的却是教练的赛后采访——被问到“是不是早就预料到”，教练先是愣了一下，随后笑着说“我比他还紧张”，这段画面迅速被做成表情包。",
      "队伍方面表示，接下来会让选手继续按计划训练，不会被外界关注打乱节奏。",
    ],
    timeline: [
      { time: "昨日 15:00", text: "预赛刷新个人最好成绩" },
      { time: "昨日 20:30", text: "决赛打破近三年国内纪录" },
      { time: "今日 08:30", text: "教练采访片段广泛传播" },
    ],
    tags: ["新人首秀", "破纪录", "赛后采访"],
    heat: 58490,
    heatWeek: 160200,
    heatMonth: 168900,
    trend: "up",
    reads: 48600,
    comments: 1980,
    publishedAt: "2026-09-10 08:10",
    image: "https://readdy.ai/api/search-image?query=Warm%20red%20and%20gold%20abstract%20track%20lanes%20with%20motion%20streaks%20and%20soft%20grain%2C%20bold%20minimal%20editorial%20sports%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-11&orientation=landscape",
  },
  {
    id: "elevator-retrofit-opinions",
    title: "小区电梯加装方案公示，居民意见分成了两派",
    summary:
      "一份张贴在公告栏里的方案说明，让同一个小区的高层与低层住户在群里讨论了一整晚。",
    categorySlug: "shehui",
    body: [
      "方案涉及三栋楼共六部电梯，公示期十五天，费用按楼层分摊，一楼住户可以选择不参与出资。方案的公示图很快被住户拍下来发到了业主群。",
      "高层住户普遍支持，认为家里有老人的情况下，加装电梯的迫切性很高；低层住户则更多关注采光、噪音以及后期维护费用的分摊方式。",
      "社区工作人员表示，公示期内会组织两场现场答疑，也会邀请第三方机构做采光影响评估，最终方案会根据反馈调整后再投票。",
    ],
    timeline: [
      { time: "本周一", text: "加装方案在公告栏公示" },
      { time: "本周二", text: "业主群展开大范围讨论" },
      { time: "本周五", text: "将举行首场现场答疑会" },
    ],
    tags: ["社区", "电梯加装", "民生讨论"],
    heat: 54210,
    heatWeek: 141700,
    heatMonth: 149600,
    trend: "flat",
    reads: 44900,
    comments: 2360,
    publishedAt: "2026-09-09 11:50",
    image: "https://readdy.ai/api/search-image?query=Muted%20warm%20grey%20beige%20abstract%20residential%20building%20blocks%20with%20soft%20daylight%20and%20grain%2C%20calm%20minimal%20editorial%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-12&orientation=landscape",
  },
  {
    id: "wudu-echo-casting",
    title: "悬疑剧《雾都回声》选角曝光，原著粉有点坐不住了",
    summary:
      "一份疑似流出的选角名单在书粉群里传开，几位主演的年龄与原著设定差距成为讨论核心。",
    categorySlug: "yingshi",
    body: [
      "《雾都回声》改编自一部口碑不错的悬疑小说，影视化消息公布后一直保持低调，直到昨天一份选角名单在多个书粉群里被转发。",
      "讨论集中在两位主角的年龄设定上。原著里角色正值青年，而名单中的演员年龄明显更大，部分书粉担心气质会偏离。",
      "也有读者表示，演技比年龄更重要，只要改编尊重原著的核心逻辑就可以接受。截至目前，制作方尚未对名单做出回应。",
    ],
    timeline: [
      { time: "昨日 13:00", text: "选角名单在书粉群流传" },
      { time: "昨日 18:20", text: "年龄设定讨论成为焦点" },
      { time: "今日", text: "制作方暂未回应" },
    ],
    tags: ["雾都回声", "选角", "原著改编"],
    heat: 50160,
    heatWeek: 132400,
    heatMonth: 138200,
    trend: "new",
    reads: 41200,
    comments: 2240,
    publishedAt: "2026-09-10 09:40",
    image: "https://readdy.ai/api/search-image?query=Moody%20teal%20and%20amber%20abstract%20foggy%20city%20silhouette%20with%20soft%20grain%20and%20diffused%20light%2C%20minimal%20editorial%20mystery%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-13&orientation=landscape",
  },
  {
    id: "musicfestival-reschedule",
    title: "音乐节临时改期，主办方的补偿方案被吐槽了",
    summary:
      "距离原定开场只剩三天，主办方宣布因场地原因改期，补偿方案公布后评论区并不买账。",
    categorySlug: "yule",
    body: [
      "主办方在昨天晚上发布公告，称因场地手续与天气双重原因，原定本周末的音乐节将顺延至下月，所有已购票用户可选择保留或退款。",
      "补偿方案包括全额退票、优先购票权益，以及为已预订交通住宿的观众提供部分补贴，但补贴需要提交凭证并经过审核。",
      "不少观众在评论区表示，补贴流程过于繁琐，实际到手比例有限；也有人认为改期决定虽然遗憾，但至少给出了退票通道。",
    ],
    timeline: [
      { time: "昨晚 22:30", text: "主办方发布改期公告" },
      { time: "昨晚 23:10", text: "补偿方案细节公布" },
      { time: "今日 08:00", text: "退票与补贴流程开始受理" },
    ],
    tags: ["音乐节", "改期", "补偿方案"],
    heat: 47680,
    heatWeek: 121900,
    heatMonth: 127400,
    trend: "down",
    reads: 38700,
    comments: 1870,
    publishedAt: "2026-09-10 06:20",
    image: "https://readdy.ai/api/search-image?query=Warm%20amber%20and%20coral%20abstract%20open%20air%20stage%20shapes%20with%20soft%20evening%20light%20and%20grain%2C%20minimal%20editorial%20festival%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=450&seq=gua-topic-14&orientation=landscape",
  },
];

export const faqs: FaqItem[] = [
  {
    question: "瓜田热榜上的“热度值”是怎么来的？",
    answer:
      "热度值综合了话题在站内的阅读量、评论互动量以及近 24 小时的讨论增速，是相对值而非绝对人数。榜单每小时刷新一次，所以同一话题在不同时间段的排名会浮动。",
  },
  {
    question: "为什么有些话题上午还在榜一，下午就掉下去了？",
    answer:
      "榜单反映的是“当下正在被讨论的热度”，偏重讨论增速而不是累计量。事件热度自然回落后，话题会从实时榜转入“最近吃瓜热点盘点”继续留存。",
  },
  {
    question: "站内话题的内容来源是哪里？",
    answer:
      "所有内容由本站编辑根据公开讨论整理撰写，只做事实脉络与观点归纳，不转载原始图文。涉及尚未证实的传闻，我们会在文中明确标注，并随事件进展更新。",
  },
  {
    question: "可以只看我关心的分类吗？",
    answer:
      "可以。首页与榜单页都提供分类筛选，你也可以直接进入对应分类页面，专注于娱乐八卦、影视综、科技数码等某一类话题。",
  },
  {
    question: "发现内容有误应该怎么反馈？",
    answer:
      "欢迎通过“关于我们”页面中的反馈邮箱联系我们。对于涉及事实错误的内容，我们会在核实后尽快更正，并在文末标注更新记录。",
  },
  {
    question: "瓜田热榜会推送消息吗？",
    answer:
      "目前不提供强制推送。你可以把感兴趣的榜单页加入书签，或在首页订阅每日盘点，我们只会在有重要更新时发送一封邮件。",
  },
];

export const testimonials = [
  {
    name: "小舟",
    role: "通勤打工人",
    text: "早高峰地铁上刷一眼榜单，进公司前就知道同事们在聊什么了，再也不用担心插不上话。",
    initial: "舟",
  },
  {
    name: "阿蓝",
    role: "追剧重度用户",
    text: "事件脉络那一栏特别好用，前因后果按时间排好，不用再自己一条条翻评论拼线索。",
    initial: "蓝",
  },
  {
    name: "老陈",
    role: "内容运营",
    text: "分类做得克制，没有把所有东西都塞进首页。我一般只看科技和社会两块，很清净。",
    initial: "陈",
  },
];

export const siteStats = [
  { label: "今日收录话题", value: "1,286", icon: "ri-fire-line" },
  { label: "覆盖主题分类", value: "6", icon: "ri-layout-grid-line" },
  { label: "每小时榜单刷新", value: "24", icon: "ri-refresh-line" },
  { label: "累计讨论条目", value: "48.6万", icon: "ri-chat-smile-2-line" },
];